ixModuleRouting("impactx.themeworld", {
    "/themeworldlist": {
        template: "<ixa-theme-world-list></ixa-theme-world-list>",
        templateUrl: "modules/themeworld/templates/themeworldlist.html",
        controller: "ThemeWorldListCtrl",
        controllerAs: "themeWorldListCtrl",
        process: "ListThemeWorld",
        workspace: "admin",
    },
    "/themeworld/:id/:activate?": {
        template: "<ixa-theme-world-detail></ixa-theme-world-detail>",
        templateUrl: "modules/themeworld/templates/themeworld.html",
        controller: "ThemeWorldCtrl",
        controllerAs: "themeWorldCtrl",
        process: "ListThemeWorld",
        workspace: "admin",
    },
    "/themeworldtenders/:id": {
        template: "<ixa-theme-world-tenders></ixa-theme-world-tenders>",
        templateUrl: "modules/themeworld/templates/themeworlditems.html",
        controller: "ThemeWorldTendersCtrl",
        controllerAs: "themeWorldItemsCtrl",
        process: "ViewThemeWorld",
        workspace: "admin",
    },
    "/themeworldlots/:id": {
        template: "<ixa-theme-world-lots></ixa-theme-world-lots>",
        templateUrl: "modules/themeworld/templates/themeworlditems.html",
        controller: "ThemeWorldLotsCtrl",
        controllerAs: "themeWorldItemsCtrl",
        process: "ViewThemeWorld",
        workspace: "admin",
    },
    "/themeworldvcats/:id": {
        template: "<ixa-theme-world-vcats></ixa-theme-world-vcats>",
        templateUrl: "modules/themeworld/templates/themeworlditems.html",
        controller: "ThemeWorldVCatsCtrl",
        controllerAs: "themeWorldItemsCtrl",
        process: "ViewThemeWorld",
        workspace: "admin",
    },
    "/themeworldsuppliers/:id": {
        template: "<ixa-theme-world-suppliers></ixa-theme-world-suppliers>",
        templateUrl: "modules/themeworld/templates/themeworlditems.html",
        controller: "ThemeWorldSuppliersCtrl",
        controllerAs: "themeWorldItemsCtrl",
        process: "ViewThemeWorld",
        workspace: "admin",
    },
    "/themeworldactivation/:id": {
        template: "<ixa-theme-world-activation></ixa-theme-world-activation>",
        templateUrl: "modules/login/templates/empty.html",
        controller: "ThemeWorldActivationController",
        controllerAs: "themeWorldActivationController"
    },
});
